import React from 'react';

const PathContext = React.createContext();


export default PathContext;